import { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link,
  LinearProgress,
  Alert,
} from "@mui/material";
import { signIn, validateSignUpCode } from "../../services/Access";
import { saveAccessToken } from "../../utils/Utils";
import { t } from "i18next";

export default function SignIn(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const url = window?.location?.href.toString();
    const urlCode = url.split("suc=")[1];
    const passwordRecoverySuccess = url.split("prs=")[1];

    if (urlCode) {
      handleValidateSignUpCode(urlCode);
    }
    if (passwordRecoverySuccess) {
      setSuccess(t("passwordRecoverySuccess"));
    }
  }, []);

  const handleClickLogin = () => {
    setLoading(true);
    setError("");
    setSuccess("");
    signIn({ email, password })
      .then((response) => {
        saveAccessToken(response?.data?.msg);
        window.location.href = "/";
      })
      .catch((e) => {
        if (e.response?.data?.msg === "2") {
          setError(
            "Tentativas excessivas de login. Clique em Esqueci Minha Senha--",
          ); /*trad */
        } else {
          setError("Usuario ou Senha Inválida"); /*trad */
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleValidateSignUpCode = (code) => {
    setLoading(true);
    setError("");
    setSuccess("");
    validateSignUpCode({ code })
      .then((response) => {
        if (response.data.success) {
          setSuccess(t("validSignUpCode"));
        } else {
          setError(t("invalidSignUpCode"));
        }
      })
      .catch((error) => {
        setError(t("invalidSignUpCode"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 400 }}>
        <Card elevation={3}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="./img/login-logo.png"
                alt="Logo"
                sx={{ pt: 4, pb: 4 }}
              />
              <TextField
                label={t("email")}
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClickLogin();
                  }
                }}
              />
              <TextField
                label={t("password")}
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClickLogin();
                  }
                }}
              />{" "}
              <Button
                variant="contained"
                fullWidth
                onClick={handleClickLogin}
                disabled={loading}
              >
                {t("login")}
              </Button>
              {loading && (
                <Box sx={{ width: "100%" }}>
                  <LinearProgress />
                </Box>
              )}
              {error && (
                <Box sx={{ width: "100%" }}>
                  <Alert variant="outlined" severity="error">
                    {error}
                  </Alert>
                </Box>
              )}
              {success && (
                <Box sx={{ width: "100%" }}>
                  <Alert variant="outlined" severity="success">
                    {success}
                  </Alert>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link href="#" underline="hover" onClick={() => props.setFormType(2)}>
            <Typography variant="body2">{t("firstAccess")}</Typography>
          </Link>

          <Link href="#" underline="hover" onClick={() => props.setFormType(3)}>
            <Typography variant="body2">{t("forgotPassword")}</Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
